<template>
  <div class="hc-compact-page hc-patient-page">
    <!-- Header Card -->
        <PageHeader icon="fas fa-user-friends">
      <template #title>
        Daftar Pasien {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola data rekam medis, identitas, dan kunjungan pasien
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/patient/add')"
                v-if="manipulateBtn == true">
                <i class="fas fa-plus"></i>
                <span>Tambah Pasien</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table purpose="master" />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Table from '@/component/patients/Table.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Table
  },

  data() {
    return {
      manipulateBtn: false,
      clinic_name : window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {
    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        
        if (access_right[a] == "3002") {
          this.manipulateBtn = true
        }
      }
    },
  },

  mounted() {
    this.setActiveMenu()
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pasien" },
      { title: "Daftar Pasien" },
    ])
  },
};
</script>
